import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

interface OpeningDTO {
  msg_type: string;
  lane: number;
  openingUser: string;
  openingMsg: string;
}

//IMPORTANT (no delete @dynamic line, is needed for angular library compiler)
// @dynamic
@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app-openBar.dialog',
  templateUrl: './openBar.dialog.component.html',
  styleUrls: ['./openBar.dialog.component.css'],
})
export class OpenBarDialogComponent implements OnInit {
  public formData: any;
  public emptyInput = false;

  constructor(
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    public data: { payload: OpeningDTO },
    public dialogRef: MatDialogRef<OpenBarDialogComponent>
  ) {}

  ngOnInit() {
    console.log('Antes' + JSON.stringify(this.data));
    if (this.data) {
      this.formData = Object.assign(new Object(), this.data);
    }
  }

  save() {
    console.log('dataFromForm' + JSON.stringify(this.formData));
    this.dialogRef.close(this.formData);
  }

  close() {
    this.dialogRef.close();
  }
  checkEmpty($event: any) {
    if ($event?.value?.lenght === 0) {
      this.emptyInput = true;
    } else {
      this.emptyInput = false;
    }
  }
}
